import styled, { css, FlattenSimpleInterpolation } from "styled-components";
import { FC } from "react";

export enum ImageOptionTestIds {
  Component = "image-option",
}

type Size = "small" | "regular" | "medium" | "large";

type ContainerProps = {
  $isFirst?: boolean;
  $isLast?: boolean;
  $disabled?: boolean;
};

const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  padding: 8px;
  gap: 8px;
  cursor: pointer;
  ${({ $isFirst }): FlattenSimpleInterpolation =>
    $isFirst
      ? css`
          border-top-left-radius: var(--size-border-radius-small);
          border-top-right-radius: var(--size-border-radius-small);
        `
      : css``}
  ${({ $isLast }): FlattenSimpleInterpolation =>
    $isLast
      ? css`
          border-bottom-left-radius: var(--size-border-radius-small);
          border-bottom-right-radius: var(--size-border-radius-small);
        `
      : css``}
  ${({ $disabled }): FlattenSimpleInterpolation =>
    $disabled
      ? css`
          color: var(--color-primary-200);
          cursor: not-allowed;
          svg {
            --main-color: var(--color-primary-200);
          }
        `
      : css`
          &:hover {
            background-color: var(--color-secondary-200);
          }
        `}
`;

type ImageProps = {
  $size: Size;
};

const Image = styled.img<ImageProps>`
  height: ${({ $size }): number => {
    switch ($size) {
      case "small":
        return 16;
      case "regular":
        return 32;
      case "medium":
        return 48;
      case "large":
        return 64;
    }
  }}px;
`;

const Text = styled.div`
  white-space: nowrap;
`;

type ImageOptionProps = {
  id?: string;
  className?: string;
  testId?: string;
  isFirst?: boolean;
  isLast?: boolean;
  disabled?: boolean;
  url: string;
  size?: Size;
  text?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

export const ImageOption: FC<ImageOptionProps> = ({
  id,
  className,
  testId,
  url,
  size = "regular",
  text,
  isFirst,
  isLast,
  disabled,
  onClick,
}) => (
  <Container
    id={id}
    className={className}
    data-testid={testId ?? ImageOptionTestIds.Component}
    $isFirst={isFirst}
    $isLast={isLast}
    $disabled={disabled}
    onClick={disabled ? undefined : onClick}
  >
    <Image src={url} alt="badge" $size={size} />
    {text && <Text>{text}</Text>}
  </Container>
);
